/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetDetailsModel {
    getFixupPrototypeFunction() { return BudgetDetailsModel.fixupPrototype; }

    static newInstance(model: Partial<BudgetDetailsModel>): BudgetDetailsModel {
        let obj = Object.assign(new BudgetDetailsModel(), model);
        BudgetDetailsModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetDetailsModel>): BudgetDetailsModel {
        if (!model) return null;
        return BudgetDetailsModel.newInstance(<BudgetDetailsModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetDetailsModel) {
        if (!obj) return;

        models.BudgetDetailsModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetDetailsModel): boolean {
        Object.setPrototypeOf(obj, BudgetDetailsModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.dimension) {
            models.BudgetDimensionDetailsModel.fixupPrototype(this.dimension);
        }
        if (this.filters) {
            models.BudgetCreateFiltersModel.fixupPrototype(this.filters);
        }
    }

    /**
     * give false for non-recurring budget
     */
    is_recurring: boolean;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

    /**
     * from date for that rule. Example: 'end_date': '2021-04-01T12:00:00.000Z
     */
    from_date: string;

    /**
     * to date for that rule. Example: 'end_date': '2021-04-01T12:00:00.000Z
     */
    to_date: string;

    /**
     * The name of the cloud service. for example, AWS.
     */
    cloud: Array<string>;

    /**
     * Specify the cloud account id to view, cloud account id is unique can be obtained from the list cloud account api.
     */
    cloud_account_id: Array<string>;

    /**
     * Dimension details for the budget. This is a unique ID and can be retrieved using the List Dimensions API.
     */
    dimension: models.BudgetDimensionDetailsModel;

    /**
     * budget filters
     */
    filters: models.BudgetCreateFiltersModel;

}
